export default "__VITE_ASSET__Bja4CeJp__"